import React, { Component } from 'react';

import AccountMenu from './../../Modules/AccountMenu'

import WerkervaringToevoegen from '../../Modules/Werkervaring/WerkervaringToevoegen'
import WerkervaringReferenties from '../../Modules/Werkervaring/WerkervaringReferenties'
import WerkervaringOverzicht from '../../Modules/Werkervaring/WerkervaringOverzicht'
import VerklaringenOverzicht from '../../Modules/Werkervaring/VerklaringenOverzicht'
import WerkervaringContent from '../../Modules/Werkervaring/WerkervaringContent'
import VerklaringenToevoegen from '../../Modules/Werkervaring/VerklaringenToevoegen'

class WerkervaringBeheren extends Component {
	constructor(props) {
		super(props)
		this.handleWorkingExperienceAdded = this.handleWorkingExperienceAdded.bind(this)
	}

	// Update the working experiences list
	handleWorkingExperienceAdded(event) {
		this.child.getWorkingExperiences()
	}
	render() {
		return (
			<div className="route">
				<AccountMenu />
				<div className="grey-bg">
					<h1 className="pageTitle">
						Beheren van werkervaring
            </h1>
					<p>Op deze webpagina kunt u uw werkervaring invoeren en wijzigen. <a href="#toelichting">Klik hier voor een toelichting op de invoer van uw werkervaring</a>.</p>
				</div>
				<div className="grey-bg">
					<WerkervaringToevoegen handle={this.handleWorkingExperienceAdded} />
				</div>
				<div className="grey-bg">
					<VerklaringenToevoegen />
				</div>
				<div className="grey-bg">
					<WerkervaringReferenties />
				</div>
				<div className="grey-bg">
					<WerkervaringOverzicht ref={instance => { this.child = instance }} />
				</div>
				<div className="grey-bg">
					<VerklaringenOverzicht />
				</div>
				<div className="grey-bg">
					<WerkervaringContent />
				</div>
			</div>
		);
	}
}

export default WerkervaringBeheren;



// WEBPACK FOOTER //
// ./src/components/Member/Pages/Werkervaring/WerkervaringBeheren.js